import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "locomotive-scroll/dist/locomotive-scroll.css";
import "remixicon/fonts/remixicon.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../Villas/VillasPage.css"; // Ensure this path is correct
import Header from "../Header";
import Footer from "../Footer/Footer";
import { Row, Col, Card } from "react-bootstrap";
import banner from "../../../assets/sectbanner.webp";
import api from "../../../config/axiosConfig";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay, faDownload } from '@fortawesome/free-solid-svg-icons';

import brochure from '../../../assets/Villas/residence-brochure.pdf';


// images for residential
import AmbassadorCottageA1 from "../../../assets/Villas/cottageA/cottageA2.webp";
import AmbassadorCottageA2 from "../../../assets/Villas/cottageA/cottageA3.webp";
// import AmbassadorCottageA3 from "../../../assets/Villas/cottageA/cottageA3.webp";

import AmbassadorCottageB1 from "../../../assets/Villas/cottageB/cottageB1.webp";
import AmbassadorCottageB2 from "../../../assets/Villas/cottageB/cottageB2.webp";
// import AmbassadorCottageB3 from "../../../assets/Villas/cottageB/cottageB3.webp";

import GovernorSuiteA1 from "../../../assets/Villas/suiteA/suiteA1.webp";
import GovernorSuiteA2 from "../../../assets/Villas/suiteA/suiteA2.webp";
// import GovernorSuiteA3 from "../../../assets/Villas/suiteA/suiteA3.webp";

import GovernorSuiteB1 from "../../../assets/Villas/suiteB/suiteB1.webp";
import GovernorSuiteB2 from "../../../assets/Villas/suiteB/suiteB2.webp";
// import GovernorSuiteB3 from "../../../assets/Villas/suiteB/suiteB3.webp";

import PresidentialSuitC1 from "../../../assets/Villas/suiteC/suiteC1.webp";
import PresidentialSuitC2 from "../../../assets/Villas/suiteC/suiteC2.webp";
// import PresidentialSuitC3 from "../../../assets/Villas/suiteC/suiteC3.webp";

import AmbassadorStudeoA1 from "../../../assets/Villas/studioA/studioA1.webp";
import AmbassadorStudeoA2 from "../../../assets/Villas/studioA/studioA2.webp";
// import AmbassadorStudeoA3 from "../../../assets/Villas/studioA/studioA2.webp";

const VillasPage = () => {
  const [residential, setResidential] = useState([]);
  const [selectedResidence, setSelectedResidence] = useState(null);
  const [mainImages, setMainImages] = useState({}); // Keep track of the main image per residence

  useEffect(() => {
    const fetchResidential = async () => {
      try {
        const response = await api.get("/residential");
        setResidential(response.data);
        if (response.data.length > 0) {
          setSelectedResidence(response.data[0]); // Default to the first item
          setMainImages(
            response.data.reduce((acc, item) => {
              acc[item.id] = roomsImages.find(
                (room) => room.residentialId === item.id
              )?.images[0]; // Set the first image as the default main image
              return acc;
            }, {})
          );
        }
      } catch (error) {
        console.error("Error fetching residential data:", error);
      }
    };
    fetchResidential();
  }, []);

  // Room images array with multiple images
  const roomsImages = [
    { id: 1, residentialId: 1, images: [AmbassadorCottageA1, AmbassadorCottageA2,  ] },
    { id: 2, residentialId: 2, images: [AmbassadorCottageB1, AmbassadorCottageB2, ] },
    { id: 3, residentialId: 3, images: [GovernorSuiteA1, GovernorSuiteA2, ] },
    { id: 4, residentialId: 4, images: [GovernorSuiteB1, GovernorSuiteB2, ] },
    { id: 5, residentialId: 5, images: [PresidentialSuitC1, PresidentialSuitC2, ] },
    { id: 6, residentialId: 6, images: [AmbassadorStudeoA1, AmbassadorStudeoA2, ] },
  ];

  const getImagesForResidential = (residentialId) => {
    const match = roomsImages.find((room) => room.residentialId === residentialId);
    return match ? match.images : [];
  };

  const handleCardClick = (residence) => {
    setSelectedResidence(residence);
  };

  const handleThumbnailClick = (residentialId, image) => {
    setMainImages((prev) => ({
      ...prev,
      [residentialId]: image,
    }));
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = brochure;
    link.download = "Belantara-brochure.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const otherResidences = residential.filter(
    (item) => item.id !== (selectedResidence ? selectedResidence.id : null)
  );

  return (
    <>
      <Header />

      <section className="VillasPage">
        {/* Main Residence */}
        <div className="residence-div py-5">
        <div className="">
        <div className="text-center"><h2 className="bannar-text pb-5">Residences</h2></div>
        </div>
          <Row className="g-0">
            <Col lg={{ span: 6, order: 1 }}
    xs={{ span: 12, order: 2 }} >
              <div className="d-flex align-content-center justify-content-center flex-column residencetextbox p-4">
                {selectedResidence && (
                  <div className="textdiv">
                    <h2>{selectedResidence.name}</h2>
                    <p>{selectedResidence.description}</p>

                    <div>
                      <Row>
                      <Col sm={6}>
                       <p>Bedrooms: {selectedResidence.bedrooms}</p>
                        </Col>
                        <Col sm={6}>
                       <p>Bathrooms: {selectedResidence.bathrooms}</p>
                        </Col>
                       
                        <Col sm={6}>
                       <p>Livingroom: {selectedResidence.livingrooms}</p>
                        </Col>
                        <Col sm={6}>
                       <p>Standard Occupancy: {selectedResidence.standardOccupancy}</p>
                        </Col>
                      </Row>
                    </div>
                    {/* Thumbnail Images */}
                    <div className="thumbnail-container pt-3">
                      {getImagesForResidential(selectedResidence.id).map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={`Thumbnail ${index + 1}`}
                          className={`thumbnail-image ${
                            mainImages[selectedResidence.id] === image ? "active" : ""
                          }`}
                          loading="lazy"
                          style={{
                            width: "60px",
                            height: "60px",
                            cursor: "pointer",
                            margin: "5px",
                            border:
                              mainImages[selectedResidence.id] === image
                                ? "2px solid #007bff"
                                : "1px solid #ccc",
                          }}
                          onClick={() => handleThumbnailClick(selectedResidence.id, image)}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </Col>
            <Col lg={{ span: 6, order: 2 }}
    xs={{ span: 12, order: 1 }} >
              <div className="d-flex align-content-center justify-content-center flex-column residenceimgbox">
                {selectedResidence && (
                  <img
                    src={mainImages[selectedResidence.id]}
                    alt={selectedResidence.name}
                    style={{ width: "100%", height: "auto" }}
                    loading="lazy"
                  />
                )}
              </div>
            </Col>
          </Row>
        </div>

        {/* Other Residences */}
        <div className="allresidences container pb-5">
       <div className="w-100 allexperienceheading">
       <h4 className="pb-4">All Residences</h4>
       </div>
       <div
            className="herodownloadBtndiv d-flex gap-2 align-items-center justify-content-center pb-4"
            onClick={handleDownload}
          >
            <FontAwesomeIcon icon={faDownload} size="2x" style={{ color: "#e6be80" }} />
            <h6 className="text-white mb-0">Download Brochure</h6>
          </div>

          <Row>
            {otherResidences.map((item) => (
              <Col lg={4} md={6} sm={12} key={item.id}>
                <Card
                  className="residence-card"
                  onClick={() => handleCardClick(item)}
                  style={{ cursor: "pointer", margin: "10px" }}
                >
                  <Card.Img
                    variant="top"
                    src={getImagesForResidential(item.id)[0]}
                    alt={item.name}
                    style={{ height: "200px", objectFit: "cover" }}
                    loading="lazy"
                  />
                  <Card.Body className="cardbody">
                    <Card.Title>
                      <h4 className="pb-3"
                      >
                      {item.name}
                      </h4>
                      <p>
                        {item.description}
                      </p>
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default VillasPage;

